import styled from 'styled-components';

export const LoginPageContainer = styled.div`
  background-color: rgb(21, 27, 54);
  z-index: 20;
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url(/bg-orb.png);
  background-repeat: no-repeat;
`;

export const LoginFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
  padding: 2.5rem;
  justify-content: center;
  width: 27rem;
  height: 25.5rem;
  background: rgb(255, 255, 255);
  box-shadow: rgba(59, 64, 89, 0.04) 0px 2px 4px, rgba(108, 114, 147, 0.06) 0px 8px 16px -4px;
  border-radius: 16px;
`;

export const LoginFormTextsContainer = styled.div`
  display: flex;
  flex-direction: column;
  -webkit-box-align: center;
  align-items: center;
  text-align: center;
  padding: 0px;
  gap: 0.5rem;
  margin: 2rem 0px;
`;
